export default {
  global: {
    ripple: false
  },
  VTextField: {
    variant: 'outlined',
    density: 'compact',
    color: 'primary',
    baseColor: 'secondary',
    hideDetails: 'auto'
  },
  VSelect: {
    variant: 'outlined',
    density: 'compact',
    color: 'primary',
    baseColor: 'secondary',
    hideDetails: 'auto'
  },
  VTextarea: {
    variant: 'outlined',
    color: 'primary',
    baseColor: 'secondary',
    hideDetails: 'auto',
    density: 'compact'
  },
  VAutocomplete: {
    variant: 'outlined',
    density: 'compact',
    hideDetails: 'auto'
  },
  VBtn: {
    ripple: false
  }
}
